export default {
    AsterSms: {
        getdata: []
    }
};